<!--
 * @Author: wh
 * @Date: 2020-08-24 19:10:33
 * @LastEditTime: 2020-09-15 12:09:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\materialConsum.vue
-->
<template>
    <div class="materialConsum">
        <div class="search-conditions-con">
            <div class="search-conditions">
                <span class="time-con" @click="showCalendarPop=true">
                    <span>{{ date }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
        </div>

        <div class="main">
            <div class="top">
                <div class="header">
                    <div class="item item0">
                        <p class="num">
                            {{ blockConsume.volume }}
                        </p>
                        <p class="describe">
                            总生产方量
                        </p>
                        <p class="describe">
                            (方)
                        </p>
                    </div>
                    <div class="item item1">
                        <p class="num">
                            {{ blockConsume.theory_consume }}
                        </p>
                        <p class="describe">
                            配比单耗
                        </p>
                        <p class="describe">
                            (千克/方)
                        </p>
                    </div>
                    <div class="item item2">
                        <p class="num">
                            {{ blockConsume.consume }}
                        </p>
                        <p class="describe">
                            实际单耗
                        </p>
                        <p class="describe">
                            (千克/方)
                        </p>
                    </div>
                    <div class="item item3">
                        <p class="num">
                            {{ blockConsume.diff_consume }}
                        </p>
                        <p class="describe">
                            单耗差值
                        </p>
                        <p class="describe">
                            (千克/方)
                        </p>
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>原材料类型</th>
                            <th>
                                配比单耗<br>(千克/方)
                            </th>
                            <th>
                                实际单耗<br>(千克/方)
                            </th>
                            <th>
                                单耗差值<br>(千克/方)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            @click="selectRow(item, index)"
                            v-for="(item, index) in materialcategory"
                            :key="index"
                            :class="{'activeRow': activeRow === index}"
                        >
                            <td class="row-tit">
                                {{ item.material_category_name }}
                            </td>
                            <td>{{ item.theory_consume }}</td>
                            <td>{{ item.consume }}</td>
                            <td>{{ item.diff_consume }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="split"></div>
            <div class="chart-con">
                <h4>按标号</h4>
                <template v-if="materialcategory.length>0">
                    <div id="lineChart"></div>
                </template>
                <template v-else>
                    <h5>暂无数据</h5>
                </template>
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月日"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_green from '@/assets/images/home/bg_green.png';
import bg_yellow from '@/assets/images/home/bg_yellow.png';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 选择时间1
            showCalendarPop: false,
            // 选择组织结构
            showOrgPop: false,
            // 当前日期
            date: '',
            // 选中组织结构
            orgName: '全部',
            columns: [
                {
                    text: '全部',
                    children: [],
                },
            ],
            // 图表数据
            data: {},
            // 组织机构
            orgData: [],
            dic_code: '',
            currentDate: new Date(),
            // 选中表格行index
            activeRow: 0,
            // 统计块数据
            blockConsume: {},
            // 运营区id
            yun_yq_id: '',
            // 片区id
            pian_q_id: '',
            // 原材料统计分类
            materialcategory: [],
            material_category_code: '',
            // 按标号统计图
            gradeData: [],
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.date = year + '-' + month;
            this.getOrg();
            this.reload();
        },
        reload() {
            this.getBlockConsume();
            this.handleMaterialcategory();
        },
        async getOrg() {
            const yyq = await this.getOrgApi();
            if (yyq) {
                const res = yyq.map(item => {
                    item.text = item.dic_name;
                    if (item.children) {
                        item.children = item.children.map(v => {
                            v.text = v.dic_name;
                            return v;
                        });
                    } else {
                        item.children = [];
                    }
                    return item;
                });
                this.orgData = res;
                this.columns[0].children = this.orgData;
            }
        },
        // 处理统计块
        async getBlockConsume() {
            const res = await this.getProductmaterialconsume();
            if (res) {
                this.blockConsume = res;
            }
        },
        // 处理原材料统计分类数据
        async handleMaterialcategory() {
            const res = await this.getProductmaterialcategory();
            if (res) {
                this.materialcategory = res;
                if (res.length > 0) {
                    this.material_category_code = res[0].material_category_code;
                    this.tabActive = 0;
                    this.handleStatisticalstrengthgrade();
                }
            }
        },
        // 按标号
        async handleStatisticalstrengthgrade() {
            const res = await this.getStatisticalstrengthgrade();
            if (res) {
                this.gradeData = {
                    xData: [],
                    theory_consume: [],
                    consume: [],
                    diff_consume: [],
                };
                res.map(item => {
                    this.gradeData.xData.push(item.strength_grade_name);
                    this.gradeData.theory_consume.push(item.theory_consume);
                    this.gradeData.consume.push(item.consume);
                    this.gradeData.diff_consume.push(item.diff_consume);
                });
                this.initGradeChart();
            }
        },
        // 获取统计块
        getProductmaterialconsume() {
            const path = '/interfaceApi/report/productmaterialconsume';
            const data = {
                year_month: this.date,
                yun_yq_id: this.yun_yq_id,
                pian_q_id: this.pian_q_id,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 统计原料分类
        getProductmaterialcategory() {
            const path = '/interfaceApi/report/productmaterialconsume/statisticalmaterialcategory';
            const data = {
                year_month: this.date,
                yun_yq_id: this.yun_yq_id,
                pian_q_id: this.pian_q_id,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 按标号
        getStatisticalstrengthgrade() {
            const path = '/interfaceApi/report/productmaterialconsume/statisticalstrengthgrade';
            const data = {
                year_month: this.date,
                material_category_code: this.material_category_code,
                yun_yq_id: this.yun_yq_id,
                pian_q_id: this.pian_q_id,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 获取组织结构    
        getOrgApi() {
            const path = '/interfaceApi/report/dictionary/get_dictionary_tree?group_code=jt_data_express_tenant&isAddSelect=true';
            return this.$axios.$get(path, { defEx: true });
        },
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = this.formatDate(value);
            this.reload();
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        confirmOrg(value) {
            this.showOrgPop = false;
            this.orgName = '';
            if (value[0]) {
                this.orgName += value[0];
            }
            if (value[1] && value[1] !== '请选择') {
                this.orgName = value[1];
            }
            if (value[2] && value[2] !== '请选择') {
                this.orgName += '-' + value[2];
            }

            if (value[2] && value[2] !== '请选择') {
                this.orgData.map(item => {
                    if (item.children) {
                        item.children.map(v => {
                            if (v.text === value[2]) {
                                this.pian_q_id = v.dic_code;
                            }
                        });
                    }
                });
                this.yun_yq_id = '';
            } else if (value[1] && value[1] !== '请选择') {
                this.orgData.map(item => {
                    if (item.text === value[1]) {
                        this.yun_yq_id = item.dic_code;
                    }
                });
                this.pian_q_id = '';
            } else {
                this.yun_yq_id = '';
                this.pian_q_id = '';
            }
            // this.getSaleday();
            this.reload();
        },
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 选中table行
        selectRow(item, index) {
            this.material_category_code = item.material_category_code;
            this.activeRow = index;
            this.handleStatisticalstrengthgrade();
        },
        // 按标号
        initGradeChart() {
            const myChart = this.$echarts.init(document.getElementById('lineChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    left: 50,
                },
                legend: {
                    data: ['配比单耗', '实际单耗', '单耗差值'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.gradeData.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(千克/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '(千克/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '配比单耗',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(113,198,176,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(78,164,150,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.theory_consume,
                    },
                    {
                        name: '实际单耗',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(242,227,65,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(220,193,41,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.consume,
                    },
                    {
                        name: '单耗差值',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        yAxisIndex: 1,
                        data: this.gradeData.diff_consume,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
    },
};
</script>
<style lang="stylus">
.materialConsum
    background #fff
    width 100%
    height 100%
    .search-conditions-con
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                position relative
                flex 1
                text-align center
                &:after
                    content ''
                    position absolute
                    right 10rpx
                    height 15rpx
                    border-right 1px solid #D7D7D7
                    margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                flex 1
                text-align center
                .org-name
                    color #3495FB
    .main
        height calc(100% - 65rpx)
        overflow-y auto
        .top
            padding 0 10rpx 10rpx 10rpx
            .header
                display flex
                margin-top 10rpx
                .item
                    flex 1
                    flex-shrink 0
                    width 25%
                    text-align center
                    .describe
                        font-size 12rpx
                    .num
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    &.item0
                        .num
                            color #5588F1
                    &.item1
                        .num
                            color #FA8436
                    &.item2
                        .num
                            color #21BDCC
                    &.item3
                        .num
                            color #FFB729
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                margin-top 10rpx
                table-layout fixed
                th
                    background rgba(235,240,252,1)
                    height 45rpx
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    font-size 14rpx
                    font-weight normal
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 45rpx
                    text-align center
                    width 40rpx
                    font-size 14rpx
                    background rgba(85,136,241,.04)
                    width 25%
                    color #5588F1
                    &.row-tit
                        color #333333
                        background rgba(235,240,252,1)
                tbody
                    tr
                        &.activeRow
                            td
                                background rgba(250,132,54,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                color #fff
                            .row-tit
                                color #823802
                                background rgba(245,242,237,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                border 1px solid rgba(222,227,239,1)
        .split
            background #F0F0F0
            height 15rpx
        .chart-con
            padding 10rpx
            #lineChart
                height 235rpx
            h5
                text-align center
                margin-top 10rpx
</style>